<template>
    <div class="card border-0 rounded-0 bg-white seller-card">
        <div class="card-body letter-spacing">
            <h5 class="fs-18 fw-semibold text-black mb-5 mb-md-8">{{ center.name }}</h5>
            <p class="small text-muted" v-html="center.address">

            </p>
            <ul class="list mt-15 mt-lg-25 ps-0 mb-0 list-unstyled d-flex justify-content-between" v-if="stats">
                <li><span class="d-block text-dark-emphasis text-uppercase fw-medium fs-12 mb-5 mb-md-8">{{
                    $t('feature.home.$stats.total_patients') }}</span><span class="d-block text-dark fw-bold">{{
        stats?.patients_total ?? '' }}</span></li>
                <li><span class="d-block text-dark-emphasis text-uppercase fw-medium fs-12 mb-5 mb-md-8">{{
                    $t('feature.home.$stats.total_caregivers') }}</span><span class="d-block text-dark fw-bold">{{
        stats?.patients_with_caregiver ?? '' }}</span></li>
            </ul>
        </div>
    </div>
</template>
<script lang="ts">
import { PropType, defineComponent } from 'vue';
import API from "@/services/api/api.service";
import { UserStats, CenterWithPermission } from "@/utils/models/user.model";
import stateStore from '@/utils/store';

export default defineComponent({
    name: "ProfileCenterCard",
    data: function () {
        return {
            stats: undefined
        } as {
            stats?: UserStats
        }
    },
    props: {
        center: {
            type: Object as PropType<CenterWithPermission>,
            required: true
        }
    },
    mounted() {
        if (stateStore.getCenterPermission(this.$props.center.id, 'index')) {
            API.getUserStats(this.$props.center.id).then((response) => {
                if (response.data.success === true && response.data.data && response.data.data.lenght !== 0) {
                    this.stats = response.data.data[0];
                }
            })
        }
    }
})
</script>